import { useQuery } from '@tanstack/react-query'

import * as walletServices from '../walletServices'
import { QUERY_KEYS } from '@/constants/queryKeys'
import { useUserAuthSessionStore } from '@/store'

export const useGetWallet = () => {
  const { token, isSessionOpen } = useUserAuthSessionStore()

  return useQuery({
    queryKey: [QUERY_KEYS.WALLET],
    queryFn: walletServices.getWallet,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: Boolean(token && isSessionOpen), // Only run if authenticated
  })
}
